import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from '../shared/services/data.service';
import { Fase } from '../../models/fase';

@Injectable()
export class FaseService extends DataService {

  private url = this.urlApi + 'v1/fase/';

  constructor(private http: HttpClient) {
    super();
  }

  cadastrarEditarFase(fase) {
    const observable = (fase.idFase)
      ? this.http.put(this.url + 'editar', fase)
      : this.http.post(this.url + 'cadastrar', fase);

    return observable.catch(this.handleError);
  }

  editarConvocacaoFase(fase: Fase) {
    return this.http.put(this.url + 'editarConvocacao', fase);
  }

  getFull(idFase: string) {
    return this.http.get<any>(this.url + 'getFull/' + idFase)
      .catch(this.handleError);
  }

  getAll(): any {
    return this.http.get(this.url + 'getAll')
      .catch(this.handleError);
  }

  getByUnidade(idUnidade): any {
    return this.http.get(this.url + 'getByUnidade/' + idUnidade)
      .catch(this.handleError);
  }
  getByEditalUnidade(idTipoEdital,idUnidade): any {
      return this.http.get(this.url + 'getByEditalUnidade/' + idTipoEdital + '/' + idUnidade)
        .catch(this.handleError);
    }
  getByEdital(idTipoEdital): any {
    return this.http.get(this.url + 'getByTipoEdital/' + idTipoEdital)
      .catch(this.handleError);
  }
  
  getAllFull() {
    return this.http.get<Fase[]>(this.url + 'getAllFull')
      .catch(this.handleError);
  }

  getComInscricoesAbertas(idTipoEdital: any = undefined) {
    if(idTipoEdital){
    return this.http.get<Fase[]>(this.url + 'getComInscricoesAbertas/'+idTipoEdital)
      
    }
    return this.http.get<Fase[]>(this.url + 'getComInscricoesAbertas')
      .catch(this.handleError);
  }

  excluiFase(idFase: string)  {
    return this.http.delete(this.url + 'excluiFase/' + idFase)
      .catch(this.handleError);
  }

  getIdEditalByIdFase(idFase) {
    return this.http.get(this.url + 'getIdEditalByIdFase/' + idFase)
      .catch(this.handleError);
  }

  getRelatorioInscritos(relatorioInscritoParams) {
    return this.http.post<any[]>(this.url + 'getRelatorioInscritos/', relatorioInscritoParams)
      .catch(this.handleError);
  }

  getRelatorioIntegracaoDetran(relatorioIntegracaoDetranParams) {
    return this.http.post<any[]>(this.url + 'getRelatorioIntegracaoDetran/', relatorioIntegracaoDetranParams)
      .catch(this.handleError);
  }

  getRelatorioIntegracaoDetranTxt(idFase, idUnidade) {
    return this.http.get<any[]>(this.url + 'getRelatorioIntegracaoDetranTxt/' + idFase + '/' + idUnidade)
      .catch(this.handleError);
  }

  getRelatorioHistoricoCandidatos(idFase) {
    return this.http.get<any[]>(this.url + 'getRelatorioHistoricoCandidatos/' + idFase)
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/fase/fase.service.ts